<p-toast [showTransformOptions]="'translateX(100%)'" [hideTransformOptions]="'translateY(100%)'"
  [hideTransitionOptions]="'300ms linear'"
  [showTransitionOptions]="'300ms linear'"
position="top-right"></p-toast>
@if (!networkStatus) {
  <div class="network-problem">
    <div class="network-problem-text">
      <i class="pi pi-wifi" style="font-size: 25px;"></i>
      <br/>
      Problème de connexion
    </div>
  </div>
}
@if (isPlatformBrowser(platformId)) {
  @if (!noHeaderFooter()) {
    <div id="header">
      <div class="wrapper-max-width flex">
        <div id="header-left">
          <div id="header-logo" routerLink="/"></div>
        </div>
        <div id="header-right">
          <div id="header-right-actions">
            @if(userType() == UserTypeEnum.BARMAN && subscription() != SubscriptionTypeEnum.BARTENDER_PREMIUM) {
              <div class="header-action-highlight-white" routerLink="/abonnement">
                @if(subscription() == null) {
                  <fa-icon [icon]="faGem"></fa-icon>
                } @else {
                  <fa-icon [icon]="faCircleUp"></fa-icon>
                }
                Abonnement
              </div>
            }
            <div class="header-action" routerLink="/carte-cadeau">
              Carte cadeau
            </div>
            @if(userType() == UserTypeEnum.CLIENT || !connected) {
              <div class="header-action" routerLink="/barmans">
                Nos barmans
              </div>
            }
            @if (!connected) {
              <div class="header-action-highlight" routerLink="/connexion">
                Connexion / Inscription
              </div>
              <div class="header-action-highlight-white" routerLink="/devenir-barman">
                Devenir barman
              </div>
            }
            @if (connected) {
              <div class="header-action" (click)="toProfil()">
                Mon compte
              </div>
            }
            @if (connected) {
              <div class="header-action" (click)="showMenu = !showMenu">
                <fa-icon [icon]="faBars"></fa-icon>
                @if (showMenu) {
                  <div class="header-menu" (mouseleave)="showMenu = false">
                    <div class="header-menu-item" routerLink="/commandes" (click)="showMenu = false">
                      Mes commandes
                    </div>
                    <div class="header-menu-item" (click)="logout(); showMenu = false;">
                      Déconnexion
                    </div>
                  </div>
                }
              </div>
            }
          </div>
          @if (!noHeaderFooter()) {
            <div id="sub-header">
              <div class="sub-header-menu">
                @for (item of subMenuItems; track item) {
                  <div class="sub-header-menu-item" (click)="openUrl(item.url)">
                    {{item.title}}
                    @if (item.subItems?.length > 0) {
                      <fa-icon class="sub-header-menu-item-icon" [icon]="faCaretDown"></fa-icon>
                    }
                    @if (item.subItems?.length > 0) {
                      <div class="sub-header-menu-item-sub">
                        @for (subItem of item.subItems; track subItem) {
                          <div class="sub-header-menu-item-sub-item" (click)="openUrl(subItem.url)">
                            {{subItem.title}}
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
          <div id="header-right-actions-short">
            <div class="header-bars" (click)="showMenu = !showMenu">
              @if (!showMenu) {
                <fa-icon [icon]="faBars" size="2x"></fa-icon>
              }
              @if (showMenu) {
                <fa-icon [icon]="faXMark" size="2x"></fa-icon>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  @if (showMenu && !noHeaderFooter()) {
    <div class="header-menu-short">
      @if(userType() == UserTypeEnum.BARMAN && subscription() != SubscriptionTypeEnum.BARTENDER_PREMIUM) {
        <div class="header-menu-short-item" routerLink="/abonnement" (click)="showMenu = false">
          @if(subscription() == null) {
            <fa-icon [icon]="faGem"></fa-icon>
          } @else {
            <fa-icon [icon]="faCircleUp"></fa-icon>
          }
          Abonnement
        </div>
      }
      @if(userType() == UserTypeEnum.CLIENT || !connected) {
        <a class="header-menu-short-item" routerLink="/barmans" (click)="showMenu = false">
          Nos barmans
        </a>
      }
      <a class="header-menu-short-item" routerLink="/carte-cadeau" (click)="showMenu = false">
        Carte cadeau
      </a>
      @if(!connected) {
        <a class="header-menu-short-item" routerLink="/connexion" (click)="showMenu = false">
          Connexion / Inscription
        </a>
        <a class="header-menu-short-item" routerLink="/devenir-barman" (click)="showMenu = false">
          Devenir barman
        </a>
      }
      @if(connected) {
        <div class="header-menu-short-item" (click)="toProfil(); showMenu = false;">
          Mon compte
        </div>
        <div class="header-menu-short-item" routerLink="/commandes" (click)="showMenu = false">
          Mes commandes
        </div>
      }
      @for (item of subMenuItems; track item) {
        <div class="header-menu-short-sub">
          <a class="header-menu-short-item" (click)="openSubMenu(item)">
            {{ item.title }}
            @if (item.subItems.length > 0) {
              <fa-icon class="header-menu-short-item-icon" [icon]="faCaretDown"></fa-icon>
            }
          </a>
          @for (subItem of item.subItems; track subItem) {
            <a class="header-menu-short-item-sub" [href]="subItem.url">
              {{subItem.title}}
            </a>
          }
        </div>
      }
      @if(connected) {
        <div class="header-menu-short-item" (click)="logout(); showMenu = false;">
          Déconnexion
        </div>
      }
    </div>
  }
}
<main>
  <div [id]="!noHeaderFooter() ? 'container' : 'container-login'">
    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </div>
</main>
@if (!noHeaderFooter() && !noFooter()) {
  <footer>
    <div class="wrapper-max-width flex flex-wrap">
      <div class="footer-section">
        <div id="footer-logo" routerLink="/"></div>
        <p>
          Pour une soirée à domicile réussie, trouvez un barman sur Commande Ton Barman, et profitez de prestations dignes d’un bar.
        </p>
      </div>
      <div class="footer-section">
        <div class="footer-title">
          Accès rapide
        </div>
        <a routerLink="/concept">Notre concept</a>
        <br/>
        <a routerLink="/contact">Nous contacter</a>
        <br/>
        <a href="https://www.commandetonbarman.fr/ctb/mentions-legales/" target="_blank">Mentions légales</a>
        <br/>
        <a href="https://www.commandetonbarman.fr/documents/CGV.pdf" target="_blank">CGV</a>
        <br/>
        <a href="https://www.commandetonbarman.fr/documents/CGU.pdf" target="_blank">CGU</a>
      </div>
      <div class="footer-section">
        <div class="footer-title">
          Nous suivre
        </div>
        <p>
          Suivez-nous pour ne rien rater : astuces cocktails, événements, et bien plus !
        </p>
        <a class="footer-social" href="https://www.facebook.com/p/Commande-Ton-Barman-61559105050119/?paipv=0&eav=Afb8rgVNDMKOTfTDay6HM0vLPTTuP8O4mx4EWa7r2ZPnJFRjsmiyjvt1fw9nIoODXfk&_rdr"
          target="_blank" title="Nous suivre sur Facebook">
          <fa-icon [icon]="faFacebook"></fa-icon>
        </a>
        <a class="footer-social" href="https://www.instagram.com/commandetonbarman/?hl=fr"
          target="_blank" title="Nous suivre sur Instagram">
          <fa-icon [icon]="faInstagram"></fa-icon>
        </a>
        <a class="footer-social" href="https://www.linkedin.com/company/commande-ton-barman/posts/?feedView=all"
          target="_blank" title="Nous suivre sur LinkedIn">
          <fa-icon [icon]="faLinkedin"></fa-icon>
        </a>
        <a class="footer-social" href="https://www.tiktok.com/@commandetonbarman"
          target="_blank" title="Nous suivre sur TikTok">
          <fa-icon [icon]="faTikTok"></fa-icon>
        </a>
        <a class="footer-social" href="https://www.youtube.com/@commandetonbarman1560"
          target="_blank" title="Nous suivre sur Youtube">
          <fa-icon [icon]="faYoutube"></fa-icon>
        </a>
      </div>
      <div class="footer-section">
        <div class="footer-title">
          Newsletter
        </div>
        <p>
          Inscrivez-vous à notre newsletter et restez informé en avant-première !
        </p>
        <div>
          <input-send (onValidate)="addNewsletter($event)"
          pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"></input-send>
        </div>
      </div>
    </div>
  </footer>
}
